// web/dyno-pwa/src/demo/controls.ts
// Fixed bottom-center pill with show-timeline + speed sliders wired to the clock.
// All innerHTML content is entirely static (no user input) so there is no XSS risk.
import { setProgress, setSpeed, getProgress, getSpeed } from "./clock";

export function installControls(): void {
  if (document.getElementById("ovr-demo-controls")) return;
  const mount = () => {
    if (document.getElementById("ovr-demo-controls")) return;
    const el = document.createElement("div");
    el.id = "ovr-demo-controls";
    // innerHTML is safe: fully static markup, no user-supplied content.
    el.innerHTML = `
      <style>
        #ovr-demo-controls{position:fixed;left:50%;bottom:14px;transform:translateX(-50%);z-index:9999;
          display:flex;gap:16px;align-items:center;padding:10px 16px;border-radius:9999px;
          background:rgba(17,24,39,.82);backdrop-filter:blur(8px);color:#e5e7eb;font:12px/1.2 ui-sans-serif,system-ui;
          box-shadow:0 6px 24px rgba(0,0,0,.4);border:1px solid rgba(255,255,255,.08)}
        #ovr-demo-controls .dot{width:8px;height:8px;border-radius:50%;background:#22c55e;animation:ovrpulse 1.6s infinite}
        #ovr-demo-controls label{display:flex;flex-direction:column;gap:2px}
        #ovr-demo-controls input{width:160px}
        @keyframes ovrpulse{0%,100%{opacity:1}50%{opacity:.35}}
      </style>
      <span class="dot"></span><span>Live demo</span>
      <label>Show timeline <input id="ovr-demo-time" type="range" min="0" max="100" step="0.5"></label>
      <label>Speed <input id="ovr-demo-speed" type="range" min="0" max="12" step="0.5"></label>
      <span id="ovr-demo-readout"></span>`;
    document.body.appendChild(el);
    const time = el.querySelector<HTMLInputElement>("#ovr-demo-time")!;
    const speed = el.querySelector<HTMLInputElement>("#ovr-demo-speed")!;
    const readout = el.querySelector<HTMLSpanElement>("#ovr-demo-readout")!;
    speed.value = String(getSpeed());
    time.value = String(getProgress() * 100);
    let dragging = false;
    const release = () => setTimeout(() => { dragging = false; }, 200);
    time.addEventListener("pointerdown", () => { dragging = true; });
    time.addEventListener("pointerup", release);
    time.addEventListener("pointercancel", release);
    time.addEventListener("input", () => { setProgress(parseFloat(time.value) / 100); });
    speed.addEventListener("input", () => { setSpeed(parseFloat(speed.value)); });
    setInterval(() => {
      if (!dragging) time.value = String(getProgress() * 100);
      readout.textContent = `${getSpeed() === 0 ? "Paused" : getSpeed() + "×"}`;
    }, 250);
  };
  if (document.body) mount(); else window.addEventListener("DOMContentLoaded", mount);
}
